import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

// SEO ottimizzato per mercato italiano
const SEO = ({
  title,
  description,
  image = 'https://www.saveyourtravel.com/pittogramma.png',
  keywords = [],
  frequency = 'weekly',
  priority = '0.5',
  canonicalBase = 'https://www.saveyourtravel.com',
  lang = 'it' // Forza italiano per SEO
}) => {
  const location = useLocation();
  const canonicalUrl = `${canonicalBase}${location.pathname}`;
  
  // Keywords italiane di default per travel marketplace
  const defaultKeywords = [
    'biglietti viaggio italia',
    'voli economici',
    'treni scontati',
    'hotel offerte',
    'marketplace viaggio',
    'save your travel'
  ];

  // Combina keywords personalizzate con default italiane
  const finalKeywords = keywords.length > 0 ? [...keywords, ...defaultKeywords] : defaultKeywords;

  return (
    <Helmet>
      <html lang={lang} />
      <title>{title}</title>

      {/* Meta base ottimizzati per Italia */}
      <meta name="description" content={description} />
      <meta name="keywords" content={finalKeywords.join(', ')} />
      <meta name="language" content="Italian" />
      <meta name="geo.region" content="IT" />
      <meta name="geo.country" content="Italia" />

      {/* Open Graph per social italiani */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="it_IT" />
      <meta property="og:site_name" content="Save Your Travel" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Canonical */}
      <link rel="canonical" href={canonicalUrl} />

      {/* Hreflang per multilingua */}
      <link rel="alternate" hrefLang="it" href={`${canonicalBase}${location.pathname}`} />
      <link rel="alternate" hrefLang="en" href={`${canonicalBase}/en${location.pathname}`} />
      <link rel="alternate" hrefLang="es" href={`${canonicalBase}/es${location.pathname}`} />
      <link rel="alternate" hrefLang="fr" href={`${canonicalBase}/fr${location.pathname}`} />
      <link rel="alternate" hrefLang="x-default" href={`${canonicalBase}${location.pathname}`} />

      {/* SEO tecnico avanzato */}
      <meta name="revisit-after" content={frequency} />
      <meta name="priority" content={priority} />
      <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
      <meta name="googlebot" content="index, follow" />
      <meta name="bingbot" content="index, follow" />
      
      {/* Structured data per viaggi */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "TravelAgency",
          "name": "Save Your Travel",
          "url": "https://www.saveyourtravel.com",
          "description": description,
          "areaServed": "IT",
          "availableLanguage": ["it", "en", "es", "fr"],
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Via dell'olmetto 18",
            "addressLocality": "Roma",
            "postalCode": "00153",
            "addressCountry": "IT"
          },
          "contactPoint": {
            "@type": "ContactPoint",
            "contactType": "customer service",
            "url": "https://www.saveyourtravel.com/contact",
            "availableLanguage": ["Italian", "English", "Spanish", "French"]
          }
        })}
      </script>
    </Helmet>
  );
};

export default SEO;
